import { Injectable } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { Observable, of } from 'rxjs';

import { HttpParamsUtils } from 'ib/internetbank-core/utils/http-params.utils';


import { HttpClientExtension } from '../../../common/services/http-client-extension.service';
import { OperationConfirmation } from '../../../shared/confirmation/core/models/operation-confirmation.model';
import { CreditEarlyRepaymentStatus } from '../credit-early-repayment-guard-popup/credit-early-repayment-quard-popup.model';


import {
	CreditPartialPaymentConfirm,
	CreditPartialPaymentCreateParams,
	CreditPartialPaymentInitialFormData,
	CreditPartialPaymentNewAmount,
	CreditPartialPaymentNewLastPayDate,
} from './credit-partial-payment.model';

@Injectable()
export class CreditPartialPaymentWizardService {

	public url: string = 'rest/biz/credit/repayment';

	constructor(private http: HttpClientExtension) { }

	public getIsEarlyPartRepaymentAvailable(id: string): Observable<CreditEarlyRepaymentStatus> {
		return this.http.get<CreditEarlyRepaymentStatus>(`${this.url}/status`, { params: HttpParamsUtils.createHttpParams({ id }) });
	}

	public getFormData(id: string): Observable<CreditPartialPaymentInitialFormData> {
		return this.http.get<CreditPartialPaymentInitialFormData>(`${this.url}/form`, { params: HttpParamsUtils.createHttpParams({ id }) });
	}

	public getApproxNewMonthPayment(
		creditId: string,
		refundAmount: number,
		maturityDate: string,
	): Observable<CreditPartialPaymentNewAmount> {
		return this.http.post<CreditPartialPaymentNewAmount>(`${this.url}/new-amount`,
			{
				creditId,
				refundAmount,
				maturityDate,
			})
			.pipe(
				catchError(() => of({ approxNewMonthlyAmount: null })),
			);
	}

	public getNewLastPayDay(
		creditId: number,
		maturityDate: string,
		refundAmount: number,
	): Observable<CreditPartialPaymentNewLastPayDate> {
		return this.http.post<CreditPartialPaymentNewLastPayDate>(`${this.url}/new-lastpaydate`, {
			creditId,
			refundAmount,
			maturityDate,
		})
			.pipe(
				catchError(() => of({ newLastPayDate: null })),
			);
	}

	public create(data: CreditPartialPaymentCreateParams): Observable<void> {
		return this.http.post<void>(`${this.url}/create`, data);
	}

	public confirm(
		operationConfirmation: OperationConfirmation | undefined,
	): Observable<CreditPartialPaymentConfirm> {
		return this.http.post<CreditPartialPaymentConfirm>(
			`${this.url}/confirm`,
			operationConfirmation,
		);
	}
}
